import config from '../Config/constants';
import { TYPE } from '../Screens/Search/types';

enum RouteList {
  ONBOARDING = 'onboarding',
  AUTH = 'auth',
  OTP = 'otp',
  SIGNUP_VERIFICATION_SUCCESS = 'verify-email',

  ROOT_TAB = 'root_tab', // for bottom tab navigation (to serve the bottom tab navigation)
  HOME = 'home',
  HOME_TAB = 'home_tab',
  BASKET = 'basket',
  BASKET_TAB = 'basket_tab',
  FEED_TAB = 'feed_tab',
  ACCOUNT_TAB = 'account_tab',
  RESERVATION = 'reservation',
  RESERVATION_TAB = 'reservation_tab',
  RESERVATION_LOCATE_ON_MAP = 'reservation_locate_on_map',
  RES_EVENT_DETAILS = 'reservation_event_details',
  RES_EVENT_DETAILS_PREVIEW = 'reservation_event_details/preview',
  RES_STORE_DETAILS = 'reservation_store_details',
  RES_STORE_DETAILS_BOOK = 'book',
  RES_CHECKOUT_ADDONS = 'reservation_checkout_addons',
  RES_CHECKOUT = 'reservation_checkout',
  MY_RESERVATIONS = 'my_reservations',
  MY_RESERVATION_DETAILS = 'my_reservations_details',
  ADDRESS_SELECTOR = 'address_selector',
  ADDRESS_ADD_EDIT = 'address_add_edit',
  ADDRESS_MAP = 'address_map',
  SEARCH = 'search',
  ORDER = 'order', // on branded the store page url is 'order'
  STORE = 'store',
  STORE_INFORMATION = 'store_information',
  STORE_REVIEWS = 'store_reviews',
  PRODUCT = 'product', // not using on mobile anymore, product page is now on modal
  PRODUCT_SPECIAL_INSTRUCTION = 'product_special_instruction', // not using on mobile anymore
  SEE_ALL = 'see_all',
  CART = 'cart',
  CHECKOUT = 'checkout',
  CHECKOUT_WEBVIEW = 'checkout_webview',
  ORDER_RATING = 'order_rating',
  ORDER_TRACKING = 'order_tracking',
  ORDER_DETAILS = 'order_details',
  ORDER_HISTORY = 'order_history',
  FEED_DESCRIPTION = 'feed_description',

  ACCOUNT = 'account',
  PROFILE = 'profile',
  CHANGE_PASSWORD = 'change_password',
  PAYMENT_METHOD = 'payment_method',
  ADD_PAYMENT = 'add_payment',
  NOTIFICATION = 'notification',
  GIFT_CARD = 'gift_card',
  REFER_AND_EARN = 'refer_and_earn',
  CHOOSE_PLAN = 'choose_plan',
  GET_HELP = 'get_help',
  PRIVACY = 'privacy',
  LEGAL = 'legal',
  LEGAL_BINDING_CONTRACT = 'legal_binding_contract',
}

// use for checking the route belong to a group
export const routeGroup = {
  isHome: [RouteList.HOME, RouteList.HOME_TAB],
  isStore: [
    RouteList.ORDER,
    RouteList.STORE,
    RouteList.STORE_INFORMATION,
    RouteList.STORE_REVIEWS,
  ],
  isReservation: [
    RouteList.RESERVATION,
    RouteList.RESERVATION_TAB,
    RouteList.RES_STORE_DETAILS,
    RouteList.RES_STORE_DETAILS_BOOK,
    RouteList.RES_EVENT_DETAILS,
    RouteList.RES_CHECKOUT_ADDONS,
    RouteList.RES_CHECKOUT,
    RouteList.MY_RESERVATION_DETAILS,
    RouteList.MY_RESERVATIONS,
  ],
  isCheckout: [
    RouteList.CHECKOUT,
    RouteList.CHECKOUT_WEBVIEW,
    RouteList.RES_CHECKOUT_ADDONS,
    RouteList.RES_CHECKOUT,
  ],
  isCheckoutWebview: [RouteList.CHECKOUT_WEBVIEW],
};

type SearchRouteProps = {
  [RouteList.SEARCH]: { type: TYPE };
};

type CheckoutWebView = {
  isMealPlan?: boolean;
  // required if payment method is card
  payment?: {
    cardNumber: string;
    cardMonth: string;
    cardYear: string;
    cardCvv: string;
  };
  storeId: string;
  url: string; // paymongo payment url
  waitSuccess?: boolean;
  backRoute?: string;
  backParams?: object;
  successRoute?: { tab: string; screen: string };
};

type ReservationStoreDetails = {
  // string | number = the url parameter become string when page is refreshed on web
  storeId: string;
  date?: string;
  defaultTab?: (typeof config.RESERVATION_TYPE.DINING)[keyof typeof config.RESERVATION_TYPE.DINING];
  eventDateRange?: number | string; // this week, this month, next month etc. value from constants
  partySize?: number | string;
  time?: string;
};

type PublicRoute = {
  [RouteList.RES_STORE_DETAILS_BOOK]: {
    id: string;
    exclusiveBooking: '1' | undefined;
  };
  [RouteList.RES_EVENT_DETAILS]: {
    eventId: string;
    size?: number;
    /**
     *  Date string in {@link config.DBDATE_FORMAT | DB date format}.
     */
    selectedDate?: string;
  };
  [RouteList.RES_EVENT_DETAILS_PREVIEW]: {
    token: string;
    eventId: string;
  };
};

export type RootRouteProps = PublicRoute & {
  [RouteList.ADDRESS_SELECTOR]: { statusBar?: boolean };
  [RouteList.CHECKOUT]: undefined | CheckoutWebView; // branded checkout webview
  [RouteList.CHECKOUT_WEBVIEW]: CheckoutWebView; // marketplace checkout webview
  [RouteList.RESERVATION_LOCATE_ON_MAP]: undefined; // on mobile, no specific route for web
};

export type AccountNavigatorProps = {
  [RouteList.PROFILE]: undefined;
};

export type BasketNavigatorProps = {
  [RouteList.BASKET_TAB]: {
    activeTab?: number; // cross platform
    scrollToTop?: boolean; // mobile
    storeId?: string; // mobile
  };
};

export type ReservationNavigatorProps = PublicRoute &
  SearchRouteProps & {
    [RouteList.RESERVATION]: { activeTab?: number };
    [RouteList.MY_RESERVATIONS]: undefined;
    [RouteList.MY_RESERVATION_DETAILS]: {
      id: string;
      reservation?: boolean | 'true';
      success?: boolean | 'true';
    };
    [RouteList.RES_STORE_DETAILS]: ReservationStoreDetails;
    [RouteList.RES_CHECKOUT_ADDONS]: undefined;
    [RouteList.RES_CHECKOUT]: undefined;
  };

export default RouteList;
